/**
 * El logo de Google Calendar. Lo usan la ventana de sincronizar y la tarjeta
 * de Calendarios en Configuración.
 */
export function GoogleCalendarLogo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M390.736 121.264H121.264V390.736H390.736V121.264Z" fill="white" />
      <path d="M390.736 512L512 390.736L451.368 380.392L390.736 390.736L379.67 446.196L390.736 512Z" fill="#EA4335" />
      <path d="M0 390.736V471.578C0 493.912 18.088 512 40.42 512H121.264L133.714 451.368L121.264 390.736L55.198 380.392L0 390.736Z" fill="#188038" />
      <path d="M512 121.264V40.42C512 18.088 493.912 0 471.58 0H390.736C383.36 30.072 379.671 52.2027 379.67 66.392C379.67 80.58 383.359 98.8707 390.736 121.264C417.556 128.944 437.767 132.784 451.368 132.784C464.969 132.784 485.18 128.945 512 121.264Z" fill="#1967D2" />
      <path d="M512 121.264H390.736V390.736H512V121.264Z" fill="#FBBC04" />
      <path d="M390.736 390.736H121.264V512H390.736V390.736Z" fill="#34A853" />
      <path d="M390.736 0H40.422C18.088 0 0 18.088 0 40.42V390.736H121.264V121.264H390.736V0Z" fill="#4285F4" />
      <text
        x="256"
        y="256"
        textAnchor="middle"
        dominantBaseline="central"
        fill="#1A73E8"
        fontSize="160"
        fontWeight="700"
        fontFamily="Google Sans, Roboto, system-ui, -apple-system, sans-serif"
      >
        31
      </text>
    </svg>
  )
}
